<template>
  <div
    id="scheduled-grocery"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <scheduled-groceries />
      </div>
      <div class="col-12">
        <scheduled-grocery-details />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { onMounted, nextTick, defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const ScheduledGroceries = defineAsyncComponent(() => import('./Grocery/ScheduledGrocery/ScheduledGroceries.vue') as any);

const ScheduledGroceryDetails = defineAsyncComponent(() => import('./Grocery/ScheduledGrocery/ScheduledGroceryDetails.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
